import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AIChat from "./AIChat";
import ResumeDraftBanner from "./ResumeDraftBanner";
import { Toaster } from "../components/ui/sonner";

export default function Layout({ children, hideFooter = false }) {
  return (
    <div className="min-h-screen flex flex-col" data-testid="app-layout">
      <Navbar />
      <main className="pt-16 flex-1">
        <ResumeDraftBanner />
        {children}
      </main>
      {!hideFooter && <Footer />}
      <AIChat />
      {/* top-center keeps toasts clear of the bottom-right chat launcher and low sticky CTAs (UX-11). */}
      <Toaster theme="light" position="top-center" />
    </div>
  );
}
